export default "__VITE_ASSET__BnQwkjLn__"